import React from 'react';
const CTA = (props) => {
    return ( 
    <button className={props.s}>
        {props.title}
    </button>
     );
}
 
export default CTA;